import {EditOutlined, ControlOutlined} from "@ant-design/icons";
import {Button} from "antd";

export default function CalculateButton({calculate, calculated}: { calculated: boolean, calculate: () => void }) {
    return <Button onClick={calculate}
                   icon={!calculated ? <ControlOutlined />: <EditOutlined/>}/>
}